import context from '../context';

export default function gettext(...args) {
  return context.gettext(...args);
}
